import { FunctionComponent } from "react";

interface ICheckboxProps {
    labelText: string;
    containerStyles?: string;
    labelStyles?: string;
    checked?: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
                
const Checkbox: FunctionComponent<ICheckboxProps> = ({ labelText, containerStyles, labelStyles, checked, onChange }) => (
    <div className={`flex items-center justify-center cursor-pointer ${containerStyles}`}>
        <input type="checkbox" className="form-checkbox h-3 w-3 accent-primary cursor-pointer" checked={checked} value={labelText} onChange={onChange} />
        <label className={`text-gray-900 font-medium ${labelStyles}`}>
            {labelText}
        </label>
    </div>
);
export default Checkbox;